export enum HabitConsistencySection {
  MOST = 'most',
  LEAST = 'least'
}

/** Which "add a habit" instructions the no-habits placeholder shows. */
export enum NoHabitsSurface {
  MOBILE = 'mobile',
  DASHBOARD = 'dashboard',
  DESKTOP = 'desktop'
}

export enum StreakWeekDayStatus {
  COMPLETED = 'completed',
  EMPTY = 'empty'
}

export enum StreakWeekRoutineType {
  MORNING = 'morning',
  EVENING = 'evening',
  FOCUS = 'focus'
}
